const PORTFOLIO_VALUE_ZERO_THRESHOLD = 0.001;

export const normalizePortfolioValue = (value: number, threshold: number = PORTFOLIO_VALUE_ZERO_THRESHOLD): number =>
    Math.abs(value) < threshold ? 0 : value;
